{
	"password": "Contraseña",
	"confirmPassword": "Confirmación de contraseña",
	"passwordToggle": {
		"show": "Mostrar contraseña",
		"hide": "Ocultar contraseña"
	}
}
